import {AccountPageEntry} from './AccountPageSectionsData';
import AmazonAccounts from './ChannelAccounts/AmazonAccounts';
import EBayAccounts from './ChannelAccounts/EBayAccounts';
import BillingHistory from './BillingHistory/BillingHistory';
import Integrations from './Integrations/Integrations';
import PlanAndBilling from './PlanAndBilling/PlanAndBilling';
import Profile from './Profile/Profile';
import Referrals from './Referrals/Referrals';
import Settings from './Settings/Settings';

type AccountPageLeftMenuOptions = {[key: string]: AccountPageEntry | null};
export const accountPageLeftMenuOptions: AccountPageLeftMenuOptions = {
  Account: null,
  [Profile.label]: Profile,
  [EBayAccounts.label]: EBayAccounts,
  [AmazonAccounts.label]: AmazonAccounts,
  [Settings.label]: Settings,

  Billing: null,
  [PlanAndBilling.label]: PlanAndBilling,
  [BillingHistory.label]: BillingHistory,

  Referral: null,
  [Referrals.label]: Referrals,

  Advanced: null,
  [Integrations.label]: Integrations,
} as AccountPageLeftMenuOptions;
